/**
 * Stickytable headers for confluence
 */
import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import Utils from './utils';

/**
 * getDefaultConfig - Get default configuration to enable sticky headers in the editor
 *
 * @param {TinymceActiveEditor} editor tinymce active editor instance
 * @return {Object} default configuration for sticky headers to work on the editor
 */
const getDefaultConfig = function (editor) {
	const defaults = {};
	defaults.objWindow = $(editor.getWin());
	defaults.scrollableArea = defaults.objWindow;
	defaults.objDocument = $(editor.getDoc());
	defaults.objHead = defaults.objDocument.find('head');

	return defaults;
};

/**
 * setupTable - Enable sticky tables for a group of table elements
 *
 * @param {JqueryHtmlElement} $table Setup stickyheaders for tables with a defined parameter for valid tables
 * @param {Object} options StickyTableHeaders jquery plugin options
 */
const setupTable = function ($table, options) {
	const editor = window.tinymce.activeEditor;

	if (editor) {
		const defaults = getDefaultConfig(editor);
		const settings = $.extend({}, defaults, options);
		const $validTables = $table.filter(function () {
			return Utils.isAValidTable(this);
		});

		$validTables.stickyTableHeaders(settings).addClass('stickyTableHeaders');

		Utils.bindHorizontalScrolling($validTables, settings.objWindow);
	}
};

/**
 * initialize stickyheaders for all confluence tables
 *
 */
const initialize = function () {
	const editor = window.tinymce.activeEditor;

	if (editor) {
		const $table = $(editor.getBody()).find('.confluenceTable');

		// the editor structure by default does not have a thead
		Utils.moveHeaderRowsToTHead($table);

		// enable all confluence tables
		setupTable($table);
	}
};

export default {
	initialize,
	setupTable,
};
